// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import axios from '@/utils/request'
import iValidate from '@/components/iValidate'
import preventReClick from '@/utils/preventReClick'
import common from './utils/common.js'
import cookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import PaymentType from '@/components/payment/PaymentType.vue';
import TeuAccount from '@/components/payment/TeuAccount.vue';
import Radio from '@/components/payment/Radio.vue';

Vue.use(preventReClick)
Vue.use(iValidate);
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.component('PaymentType', PaymentType)
Vue.component('TeuAccount', TeuAccount)
Vue.component('Radio', Radio)
Vue.use(common)
Vue.use(cookie)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$downloadBaseUrl = process.env.NODE_ENV == 'production' ? 'http://www.wiffa-coin.com' : (process.env.NODE_ENV == 'development'?'http://localhost:8080' : 'http://test.wiffa-coin.com')

axios.defaults.withCredentials=true

// Vue.prototype.$http = http
// Vue.use(Print);

const messages = {
  en: {
    self: require('./lang/en'),
    ...enLocale
  },
  zh: {
    self: require('./lang/zh'),
    ...zhLocale
  }
}
const i18n = new VueI18n(
  {
    locale: localStorage.getItem('locale') || 'zh',
    messages
  }
)

ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})
